import React from 'react';
import { Link } from 'react-router-dom';
import { bcg, title, redirectLink } from './ErrorPage.module.css';
import { CONTACT_US_LINK } from '../../utils/constants';
import { imgUrlGenerate } from '../../helpers';

const ErrorPage = () => (
  <div className={`${bcg}`}>
    <h1 className={`title-big ${title}`}>
      An error occurred on the form submission.
              <br />
      You could come back to 'Contact Us' page or try to send it again later.
    </h1>
    <Link to={`/${CONTACT_US_LINK}/`} className={redirectLink}>
      Go Back
        <img src={imgUrlGenerate(`go_back-arrow.svg`)} alt='Go back' />
    </Link>
  </div>
)

export default ErrorPage